<template>
  <div id="wrapper">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <h2 class="font-light m-b-xs">
            Biblio History
          </h2>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="hpanel">
        <div class="panel-heading">
          biblio Preview <span class="label label-info" v-if="selectedLog">{{selectedLog.updated_at | moment('LLL')}}</span>
          <div class="pull-right text-right">
            <div class="btn-group" style="margin-left: 20px">
              <button class="btn btn-xs btn-info btn-outline" @click="fullScreen"><i id="iconFullScreen" class="fa fa-expand"></i></button>
            </div>
          </div>

        </div>
        <div class="panel-body">
          <biblio :content="biblioContent" :type="'preview'" ref="biblio"></biblio>
        </div>
      </div>
      <div class="hpanel">
        <div class="panel-heading">
          Biblio history by Users
          <div class="pull-right text-right">
            <div class="btn-group">
              <button class="btn btn-info btn-xs" @click="$router.back()">Back to edition</button>
            </div>
          </div>
        </div>
        <div class="panel-body">
          <div class="table-responsive col-lg-12">
            <table cellpadding="1" cellspacing="1" class="table table-bordered table-striped">
              <thead>
              <tr>
                <th class="col-xs-3">Date</th>
                <th class="col-xs-6">User</th>
                <th class="col-xs-3 text-center">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(log, key) in history" :key="key">
                <td>{{log.updated_at | moment('LLL')}}</td>
                <td>{{log.user.lastname}} {{log.user.firstname}}</td>
                <td class="text-center">
                  <button class="btn btn-xs btn-info" @click="preview(log)">preview</button>
                  <button class="btn btn-xs btn-info" @click="selectedLog = log" data-toggle="modal" data-target="#modalRecoverBiblio">recover</button>
                  <button class="btn btn-xs btn-info" @click="duplicate(log)">duplicate</button>
                  <button class="btn btn-xs btn-info" @click="exportBiblio(log)">export</button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="panel-footer">
          Table - {{history.length}} rows
        </div>
      </div>
    </div>

    <div v-if="selectedLog" id="modalRecoverBiblio" class="modal fade hmodal-warning" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Recover biblio</h4>
          </div>
          <div class="modal-body">
            <div>Are you sure you want to recover this biblio to : {{selectedLog.updated_at | moment('LLL')}}?</div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" data-dismiss="modal" aria-hidden="true">Close</button>
            <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle" @click="recover(selectedLog)">Recover</vue-ladda>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Biblio from '../../components/biblio/Biblio'
import VueLadda from 'vue-ladda'

export default {
  components: {Biblio, VueLadda},
  name: 'BiblioHistory',
  data () {
    return {
      biblioId: null,
      biblioContent: '{}',
      history: [],
      selectedLog: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  watch: {
    selectedLog: function (val) {
      this.biblioContent = val.content
    }
  },
  methods: {
    getResources: function () {
      if (this.biblioId !== null && typeof this.biblioId !== 'undefined') {
        this.axios.get('/biblio/' + this.biblioId + '/history')
          .then((response) => {
            this.history = response.data
            if (this.history.length !== 0) {
              this.selectedLog = this.history[0]
            }
          }).catch(function (error) {
            this.$notify({
              type: 'danger',
              title: 'An error has occurred',
              content: 'We are sorry but we encountered an error, please refresh your page or contact support!',
              placement: 'bottom-right'
            })
          })
      }
    },
    preview: function (log) {
      this.selectedLog = log
    },
    recover: function (log) {
      this.submit.loading = true

      this.axios.patch('biblio/' + log.id + '/recover').then((response) => {
        this.$notify({
          type: 'success',
          title: 'Well done!',
          content: 'Biblio was recovered',
          placement: 'bottom-right'
        })
        $('#modalRecoverBiblio').modal('hide')
        setTimeout(() => {
          this.$router.back()
        }, 500)
      }).catch((error) => {
        this.$notify({
          type: 'danger',
          title: 'An error has occurred',
          content: 'We are sorry but we encountered an error, please refresh your page or contact support!',
          placement: 'bottom-right'
        })
      }).finally(() => {
        this.submit.loading = false
      })
    },
    duplicate: function (log) {
      this.axios.post('biblio/' + log.id + '/duplicate').then((response) => {
        this.$notify({
          type: 'success',
          title: 'Well done!',
          content: 'Biblio was duplicated',
          placement: 'bottom-right'
        })
        localStorage.setItem('listIdSelected', response.data.id)
        this.$router.back()
      }).catch((error) => {
        this.$notify({
          type: 'danger',
          title: 'An error has occurred',
          content: 'We are sorry but we encountered an error, please refresh your page or contact support!',
          placement: 'bottom-right'
        })
      })
    },
    exportBiblio: function (log) {
      this.$refs.biblio.showModalExportJson()
    },
    fullScreen: function (e) {
      this.$refs.biblio.fullScreen(e)
      e.preventDefault()
      e.stopPropagation()
    }
  },
  beforeMount () {
    this.biblioId = parseInt(this.$route.params.biblio_id)
    this.getResources()
  }

}
</script>



// WEBPACK FOOTER //
// src/pages/biblio/BiblioHistory.vue